
import { Util } from './../constants/actionType';
import { InHomeUtils } from './inhomeUtils'
import { catchJSException, logOtherInfo, detailsInfo } from './../service/logService';
import { updateNRTime } from './../action/nrCustInteractions';

export const getPieEncryptionValue = (EncryptInput, EncryptType, visitId) => {
    let encryptedValue = {
    };
    try {
        if (!window.PIE.key_id && !window.PIE.phase) {
            logOtherInfo(detailsInfo('pieEncryption', visitId, 'pieEncryption-notLoaded', "Inside pieEncryption"));
            return false;
        } else {
            if (EncryptType === Util.onCreditCheck) {
                encryptedValue.protected_ssn = EncryptInput.ssnValue ? window.ProtectString(EncryptInput.ssnValue, null) && window.ProtectString(EncryptInput.ssnValue, null).length > 0 ? window.ProtectString(EncryptInput.ssnValue, null)[0] : "" : "";
                encryptedValue.protected_dob = window.ProtectString(EncryptInput.dobValue, null)[0];
                encryptedValue.key_id = window.PIE.key_id;
                encryptedValue.phase = window.PIE.phase;
                return encryptedValue;
            }
            if (EncryptType === Util.onDeposit) {
                encryptedValue.cardNum = EncryptInput.cardNum ? window.ProtectString(EncryptInput.cardNum, null) && window.ProtectString(EncryptInput.cardNum, null).length > 0 ? window.ProtectString(EncryptInput.cardNum, null)[0] : "" : "";
                encryptedValue.securityCode = window.ProtectString(EncryptInput.securityCode, null)[0];
                encryptedValue.profileName = window.ProtectString(EncryptInput.profileName, null)[0];
                return encryptedValue;
            }
            //CHECKING OR SAVINGS ACCOUNT
            if (EncryptType === Util.onAutopay && (EncryptInput.isCheckingAccount || EncryptInput.isSavingsAccount)) {
                encryptedValue.bankAcctNum = EncryptInput.accountNumber ? window.ProtectString(EncryptInput.accountNumber, null) && window.ProtectString(EncryptInput.accountNumber, null).length > 0 ? window.ProtectString(EncryptInput.accountNumber, null)[0] : "" : "";
                encryptedValue.key_id = window.PIE.key_id;
                encryptedValue.phase = window.PIE.phase;
                return encryptedValue;
            }
            //CREDIT OR DEBIT ACCOUNT
            else if (EncryptType === Util.onAutopay && (EncryptInput.isCreditAccount || EncryptInput.isDebitAccount)) {
                if (window.ValidatePANChecksum(EncryptInput.cardNumber)) {
                    let cardencryptedValue = window.ProtectPANandCVV(EncryptInput.cardNumber, EncryptInput.CVVNumber);
                    if (InHomeUtils.isNotNull(cardencryptedValue) && cardencryptedValue.length > 0) {
                        encryptedValue.cardnumber = cardencryptedValue[0]; // this is for cardnum
                        encryptedValue.securityCode = cardencryptedValue[1]; // This is for cvv securitycode 
                        encryptedValue.key_id = window.PIE.key_id;
                        encryptedValue.phase = window.PIE.phase;
                        return encryptedValue;
                    }
                }
                else {
                    logOtherInfo(detailsInfo('pieEncryptionCD', visitId, 'pieEncryption-notLoaded', "Inside pieEncryption"));
                    return false;
                }
            }
            else {
                logOtherInfo(detailsInfo('pieEncryption', visitId, 'pieEncryption-notLoaded', "Inside pieEncryption"));
                return false;
            }
        }
    } catch (ex) {
        catchJSException('CommonUtil', visitId, 'util_getPieEncryptionValue', ex);
        return false;
    }
}

export const getPieEncryptionVepsPayment = (EncryptInput, visitId) => {
    let encryptedValue = {
    };
    try {
        if (!window.PIE.key_id && !window.PIE.phase) {
            return false;
        }
        else {
            var creditCard = EncryptInput.cardNum;
            var cvv = EncryptInput.securityCode;
            if (window.ValidatePANChecksum(creditCard)) {
                encryptedValue = window.ProtectPANandCVV(creditCard, cvv);
                if (encryptedValue) {
                    encryptedValue.key_id = window.PIE.key_id;
                    encryptedValue.phase = window.PIE.phase;
                    return encryptedValue;
                }
            } else {
                return false;
            }
        }
    } catch (ex) {
        catchJSException('CommonUtil', visitId, 'util_getPieEncryptionVepsPayment', ex);
        return false;
    }
}

export const contentPrintFaxProof = (id, visitId) => {
    try {
        let page = document.getElementById(id);
        let htmlContent = "<html><head><style>" +
            `.w_employee-detail-form {
            display: table;
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
            margin-top: 11px;
        }
        .field-row {display: table-row;}
        .field-cell {display: table-cell;width: 50%;border: 1px solid #ccc;border-collapse: collapse;padding: 10px;height: 45px;}
        .vz_logo a:before { content:  url(data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNjU4LjIgMTQ2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA2NTguMiAxNDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48Zz48cG9seWdvbiBmaWxsPSIjRDUyQjFFIiBwb2ludHM9IjY0My43LDAgNjA3LjgsNzYuOCA1OTQuMyw0Ny43IDU3OS43LDQ3LjcgNjAxLjksOTUuMyA2MTMuNyw5NS4zIDY1OC4yLDAgCSIvPjxwYXRoIGQ9Ik00ODkuNywxNDIuNmgyOC45Vjg5LjdjMC0xMi4xLDctMjAuNiwxNy40LTIwLjZjMTAsMCwxNS4yLDcsMTUuMiwxNy4xdjU2LjRoMjguOVY4MC43YzAtMjEtMTIuNi0zNS44LTMzLTM1LjggYy0xMywwLTIyLjEsNS42LTI4LjksMTUuOGgtMC42di0xM2gtMjhMNDg5LjcsMTQyLjZMNDg5LjcsMTQyLjZ6IE00MzIuOSw0NS4xYy0zMC4yLDAtNTAuNCwyMS43LTUwLjQsNTAuMyBjMCwyOC40LDIwLjIsNTAuMyw1MC40LDUwLjNzNTAuNC0yMS45LDUwLjQtNTAuM0M0ODMuNCw2Ni44LDQ2My4xLDQ1LjEsNDMyLjksNDUuMXogTTQzMi43LDEyNC4zYy0xMy43LDAtMjEtMTEuNS0yMS0yOC45CWMwLTE3LjYsNy4yLTI4LjksMjEtMjguOWMxMy43LDAsMjEuMywxMS4zLDIxLjMsMjguOUM0NTQuMSwxMTIuOCw0NDYuNSwxMjQuMyw0MzIuNywxMjQuM3ogTTMwMC4xLDE0Mi42aDgxLjJ2LTIyLjhoLTQ2di0wLjYJbDQ0LTQ5LjNWNDcuNmgtNzkuMnYyMi45aDQ0LjV2MC42bC00NC41LDQ5LjdMMzAwLjEsMTQyLjZMMzAwLjEsMTQyLjZ6IE0yNjMsMTQyLjZoMjkuMVY0Ny43SDI2M1YxNDIuNnogTTE5NS41LDE0Mi42aDI5Vjk5CWMwLTE5LjgsMTEuOS0yOC42LDMwLTI2LjFoMC42di0yNWMtMS41LTAuNi0zLjItMC43LTUuOS0wLjdjLTExLjMsMC0xOC45LDUuMi0yNS40LDE2LjNoLTAuNlY0Ny43aC0yNy43VjE0Mi42eiBNMTQyLjMsMTI0LjQJYy0xMi44LDAtMjAuNi04LjMtMjIuMS0yMS4xaDY4LjRjMC4yLTIwLjQtNS4yLTM2LjctMTYuNS00Ni45Yy04LTcuNC0xOC41LTExLjUtMzEuOS0xMS41Yy0yOC42LDAtNDguNCwyMS43LTQ4LjQsNTAuMQljMCwyOC42LDE4LjksNTAuNCw1MC4zLDUwLjRjMTEuOSwwLDIxLjMtMy4yLDI5LjEtOC41YzguMy01LjcsMTQuMy0xNC4xLDE1LjktMjIuNGgtMjcuOEMxNTYuNiwxMjAuNywxNTAuOCwxMjQuNCwxNDIuMywxMjQuNHogTTE0MC44LDY1LjZjMTAuMiwwLDE3LjIsNy42LDE4LjQsMTguN2gtMzguOEMxMjIuNyw3My4xLDEyOC44LDY1LjYsMTQwLjgsNjUuNnogTTM0LDE0Mi42aDMwLjRsMzMtOTQuOUg2OC4zbC0xOC41LDYxaC0wLjQJbC0xOC41LTYxSDFMMzQsMTQyLjZ6IE0yNjMsMTMuOWgyOS4xdjI1LjhIMjYzVjEzLjl6Ii8+PC9nPjwvc3ZnPg==); }    
        .vz_logo a {
                display: block;
                height: 42px;
                overflow: hidden;
                width: 188px;
                float: left;
                background-image: url(data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNjU4LjIgMTQ2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA2NTguMiAxNDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48Zz48cG9seWdvbiBmaWxsPSIjRDUyQjFFIiBwb2ludHM9IjY0My43LDAgNjA3LjgsNzYuOCA1OTQuMyw0Ny43IDU3OS43LDQ3LjcgNjAxLjksOTUuMyA2MTMuNyw5NS4zIDY1OC4yLDAgCSIvPjxwYXRoIGQ9Ik00ODkuNywxNDIuNmgyOC45Vjg5LjdjMC0xMi4xLDctMjAuNiwxNy40LTIwLjZjMTAsMCwxNS4yLDcsMTUuMiwxNy4xdjU2LjRoMjguOVY4MC43YzAtMjEtMTIuNi0zNS44LTMzLTM1LjggYy0xMywwLTIyLjEsNS42LTI4LjksMTUuOGgtMC42di0xM2gtMjhMNDg5LjcsMTQyLjZMNDg5LjcsMTQyLjZ6IE00MzIuOSw0NS4xYy0zMC4yLDAtNTAuNCwyMS43LTUwLjQsNTAuMyBjMCwyOC40LDIwLjIsNTAuMyw1MC40LDUwLjNzNTAuNC0yMS45LDUwLjQtNTAuM0M0ODMuNCw2Ni44LDQ2My4xLDQ1LjEsNDMyLjksNDUuMXogTTQzMi43LDEyNC4zYy0xMy43LDAtMjEtMTEuNS0yMS0yOC45CWMwLTE3LjYsNy4yLTI4LjksMjEtMjguOWMxMy43LDAsMjEuMywxMS4zLDIxLjMsMjguOUM0NTQuMSwxMTIuOCw0NDYuNSwxMjQuMyw0MzIuNywxMjQuM3ogTTMwMC4xLDE0Mi42aDgxLjJ2LTIyLjhoLTQ2di0wLjYJbDQ0LTQ5LjNWNDcuNmgtNzkuMnYyMi45aDQ0LjV2MC42bC00NC41LDQ5LjdMMzAwLjEsMTQyLjZMMzAwLjEsMTQyLjZ6IE0yNjMsMTQyLjZoMjkuMVY0Ny43SDI2M1YxNDIuNnogTTE5NS41LDE0Mi42aDI5Vjk5CWMwLTE5LjgsMTEuOS0yOC42LDMwLTI2LjFoMC42di0yNWMtMS41LTAuNi0zLjItMC43LTUuOS0wLjdjLTExLjMsMC0xOC45LDUuMi0yNS40LDE2LjNoLTAuNlY0Ny43aC0yNy43VjE0Mi42eiBNMTQyLjMsMTI0LjQJYy0xMi44LDAtMjAuNi04LjMtMjIuMS0yMS4xaDY4LjRjMC4yLTIwLjQtNS4yLTM2LjctMTYuNS00Ni45Yy04LTcuNC0xOC41LTExLjUtMzEuOS0xMS41Yy0yOC42LDAtNDguNCwyMS43LTQ4LjQsNTAuMQljMCwyOC42LDE4LjksNTAuNCw1MC4zLDUwLjRjMTEuOSwwLDIxLjMtMy4yLDI5LjEtOC41YzguMy01LjcsMTQuMy0xNC4xLDE1LjktMjIuNGgtMjcuOEMxNTYuNiwxMjAuNywxNTAuOCwxMjQuNCwxNDIuMywxMjQuNHogTTE0MC44LDY1LjZjMTAuMiwwLDE3LjIsNy42LDE4LjQsMTguN2gtMzguOEMxMjIuNyw3My4xLDEyOC44LDY1LjYsMTQwLjgsNjUuNnogTTM0LDE0Mi42aDMwLjRsMzMtOTQuOUg2OC4zbC0xOC41LDYxaC0wLjQJbC0xOC41LTYxSDFMMzQsMTQyLjZ6IE0yNjMsMTMuOWgyOS4xdjI1LjhIMjYzVjEzLjl6Ii8+PC9nPjwvc3ZnPg==);
            }
            .left {
                overflow: auto;
            }
            .text-black{
                font-size: 2.25rem;
                line-height: 2.375rem;
                color: #000;
                font-weight: 700;
                font-family: BrandFont-Display,Arial,sans-serif;
            }
            .print-btn{
                display: none;
            }
            .columns h6 {
                font-size: 1.125rem;
                line-height: 1.5rem;
                margin: 1rem 0;
            }
        `
            + " </style></head><body><div class='vzt'>" + page.innerHTML + "</div></body></html>";
        let printWin = window.open('', '', 'left=0,top=0,width=400,height=400,toolbar=0,scrollbars=0,status=0');
        printWin.document.write(htmlContent);
        printWin.document.close();
        printWin.focus();
        //Added for Chrome - Print window is blocking parent window on close
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
            let showPopup = false;
            printWin.onbeforeunload = function () {
                if (showPopup) {
                    return 'Please use Cancel button to close the Print Preview window.\n';
                } else {
                    showPopup = true;
                }
            }
            printWin.onunload = function () {
                if (window.opener && window.opener.location) {
                    window.opener.location.reload();
                }
            }
            printWin.print();
            printWin.close();
        } else {
            printWin.print();
            printWin.close();
        }
    }
    catch (ex) {

        catchJSException('CommonUtil', visitId, 'util_contentPrint', ex);
    }
}

export const contentPrint = (id, visitId, source = '') => {
    try {
        let page = document.getElementById(id);
        let htmlContent = "<html><body><div class='vzt'>" + page.innerHTML + "</div></body></html>";
        const isFbeIosParam = source === 'FBE_EC' && navigator.userAgent?.toLowerCase()?.includes('iphone') ? '_blank' : '';
        let printWin = window.open('', isFbeIosParam, 'left=0,top=0,width=400,height=400,toolbar=0,scrollbars=0,status=0');
        printWin.document.write(htmlContent);
        printWin.document.close();
        printWin.focus();
        //Added for Chrome - Print window is blocking parent window on close
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
            let showPopup = false;
            printWin.onbeforeunload = function () {
                if (showPopup) {
                    return 'Please use Cancel button to close the Print Preview window.\n';
                } else {
                    showPopup = true;
                }
            }
            printWin.onunload = function () {
                if (window.opener && window.opener.location) {
                    window.opener.location.reload();
                }
            }
            printWin.print();
            printWin.close();
        } else {
            printWin.print();
            printWin.close();
        }
    }
    catch (ex) {

        catchJSException('CommonUtil', visitId, 'util_contentPrint', ex);
    }
}

export const updateNonProduct = (nonProductIds, prods, visitId) => {
    let nonSupportedProducts = {
        coreProduct: { data: [], tv: [], voice: [] },
        subProduct: { data: [], tv: [], voice: [] },
        dataProducts: [], tvProducts: [], voiceProducts: [], prodsCount: 0
    }
    let isFeeWaived = false;
    try {
        if (InHomeUtils.isNotNull(prods.coreProduct)) {
            if (InHomeUtils.isNotNull(prods.coreProduct.data) && prods.coreProduct.data.length > 0) {
                prods.coreProduct.data.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.prodId) && isMatch(prod.prodId, nonProductIds)) {
                        nonSupportedProducts.coreProduct.data.push(prod);
                        nonSupportedProducts.dataProducts.push({
                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                        });
                        nonSupportedProducts.prodsCount++;
                    }
                });
            }
            if (InHomeUtils.isNotNull(prods.coreProduct.tv) && prods.coreProduct.tv.length > 0) {
                prods.coreProduct.tv.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.prodId) && isMatch(prod.prodId, nonProductIds)) {
                        nonSupportedProducts.coreProduct.tv.push(prod);
                        isFeeWaived = (prod.prodType === "SPORTSPASS" && prod.prodTypeVal === "ANNUALRENEWAL") ? true : false;
                        if (!isFeeWaived) {
                            nonSupportedProducts.tvProducts.push({
                                id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                            });
                            nonSupportedProducts.prodsCount++;
                        }
                    }
                });
            }
            if (InHomeUtils.isNotNull(prods.coreProduct.voice) && prods.coreProduct.voice.length > 0) {
                prods.coreProduct.voice.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.prodId) && isMatch(prod.prodId, nonProductIds)) {
                        nonSupportedProducts.coreProduct.voice.push(prod);
                        nonSupportedProducts.voiceProducts.push({
                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                        });
                        nonSupportedProducts.prodsCount++;
                    }
                });
            }
        }
        if (InHomeUtils.isNotNull(prods.subProduct)) {
            if (InHomeUtils.isNotNull(prods.subProduct.data) && prods.subProduct.data.length > 0) {
                prods.subProduct.data.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.prodId) && isMatch(prod.prodId, nonProductIds)) {
                        nonSupportedProducts.subProduct.data.push(prod);
                        nonSupportedProducts.dataProducts.push({
                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                        });
                        nonSupportedProducts.prodsCount++;
                    }
                });
            }
            if (InHomeUtils.isNotNull(prods.subProduct.tv) && prods.subProduct.tv.length > 0) {
                prods.subProduct.tv.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.prodId) && isMatch(prod.prodId, nonProductIds)) {
                        nonSupportedProducts.subProduct.tv.push(prod);
                        isFeeWaived = (prod.prodType === "SPORTSPASS" && prod.prodTypeVal === "ANNUALRENEWAL") ? true : false;
                        if (!isFeeWaived) {
                            nonSupportedProducts.tvProducts.push({
                                id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                            });
                            nonSupportedProducts.prodsCount++;
                        }
                    }
                });
            }
            if (InHomeUtils.isNotNull(prods.subProduct.voice) && prods.subProduct.voice.length > 0) {
                prods.subProduct.voice.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.prodId) && isMatch(prod.prodId, nonProductIds)) {
                        nonSupportedProducts.subProduct.voice.push(prod);
                        nonSupportedProducts.voiceProducts.push({
                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                        });
                        nonSupportedProducts.prodsCount++;
                    }
                });
            }
        }
    }
    catch (ex) {
        catchJSException('CommonUtil', visitId, 'util_updateNonProduct', ex);
    }

    return nonSupportedProducts;
}

export const isMatch = (id, nonProductIds, visitId) => {
    try {
        if (InHomeUtils.isNotNull(nonProductIds) && nonProductIds.length > 0) {
            for (let count = 0; count < nonProductIds.length; count++) {
                if (nonProductIds[count] === id) {
                    return false;
                }
            }
            return true;
        }
    }
    catch (ex) {
        catchJSException('CommonUtil', visitId, 'util_isMatch', ex);
        return false;
    }
}

export const getNRCurrentTime = (fromPage, dispatch) => {
    const date = new Date(), curentTime = date.getTime();
    const newNrTimeData = {
        fromTime: curentTime,
        fromPage: fromPage,
        toTime: '',
        toPage: ''
    };
    updateNRTime(newNrTimeData, dispatch);
    const nrTimeData = { ...newNrTimeData };
    console.log('nrTimeData::', nrTimeData);
    window.nrTimeState = nrTimeData;
    return nrTimeData;
}

export const logNRTime = (nrTimeState, dispatch, toPage) => {
    if (nrTimeState) {
        const date = new Date();
        const currentTime = date.getTime(),
            newNrTimeData = {
                toTime: currentTime,
                toPage: toPage
            };
        const updatedTime = { ...nrTimeState, ...newNrTimeData };
        updateNRTime(updatedTime, dispatch);
        if (updatedTime.fromTime) {
            console.log('to time::', currentTime);
            const difference = (currentTime - updatedTime.fromTime) / 1000;
            console.log(`%c INFO ${updatedTime.fromPage} to ${updatedTime.toPage} `, 'background:green; color:white', 'Duration::', difference);
            window.nrTimeState = null;
            window.newrelic && window.newrelic.addPageAction(`${updatedTime.fromPage} to ${updatedTime.toPage}`, { durations: difference });
        }
    }
}

export const getLQWidgetConfig = (sourceInfo, seqType = '') => {
    let lqScriptURL = '';
    if(window.location.host.indexOf('nte1aws') > -1){ 
        lqScriptURL = 'https://wwwnte1aws.ebiz.verizon.com/inhome/vzlqwidget.js'; 
    }
    else if(window.location.host.indexOf('nte3aws') > -1){ 
        lqScriptURL = 'https://wwwnte3aws.ebiz.verizon.com/inhome/vzlqwidget.js'; 
    }
    else if(window.location.host.indexOf('awssit') > -1 || window.location.host.indexOf('localhost') > -1){ 
        lqScriptURL = 'https://wwwawssit.ebiz.verizon.com/inhome/vzlqwidget.js'; 
    } 
    else if((window.location.host.indexOf('98.verizon.com') > -1) || (window.location.href.indexOf('lqTestQualification=Y') > -1)){ 
        lqScriptURL = 'https://www98.verizon.com/inhome/vzlqwidget.js'; 
    }
    else if(window.location.host.indexOf('preprod-east') > -1){ 
        lqScriptURL = 'https://preprod-east-gz.vpc.verizon.com/inhome/vzlqwidget.js'; 
    }           
    else{
        lqScriptURL = 'https://www.verizon.com/inhome/vzlqwidget.js'; 
    }       
  
    return {
      lqScriptURL,
      vzwlqwidgetconfig: {
        targetElementId: 'lq-widget-root',
        lqApi: 'LOCUS_API',
        platform: '',
        flowType: '',
        sourceInfo,
        seqType,
        renderSettings: {
          mode: 'modal',
          externalTrigger: ['.checkAvailabilityBtn'],
          miniLq: {
            enabled: true,
            layout: {
              default: {
                topPosition: '69px',
                zIndex: '900',
              },
              mq_lg: {
                breakPoint: '1020px',
                topPosition: '120px',
                zIndex: '899',
              },
            },
            options: { sticky: 'true' },
          },
        },
      },
    };
  };

  export const closeLqWidget = () => {
    const closeButton = window.document.getElementById('closeWidget');
    if (closeButton) {
      closeButton.click();
    }
  };
  